import React from 'react';
import { Helmet } from 'react-helmet';
import { createRoot } from 'react-dom/client';
import { Admin, CustomRoutes, Resource } from 'react-admin';
import GroupIcon from '@mui/icons-material/Group';
import EventIcon from '@mui/icons-material/Event';
import CategoryIcon from '@mui/icons-material/Category';
import { Route } from 'react-router-dom';

import { LoginPage, OAuthCallback, RootPage } from './pages';
import { dataProvider } from './providers/dataProvider';
import { UserEdit, UsersList } from './pages/User';
import { EventEdit, EventCreate, EventsList } from './pages/Event';
import { CategoryEdit, CategoryCreate, CategoriesList } from './pages/Category';

import { customTheme } from './theme';
import { USER_ROLES } from './constants';

import authProviderBridge from './providers/authProviders/authProviderBridge';
import { UserRole } from './types';
import { rolePermission } from './utils';

const { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;

const App = () => {
  return (
    <>
      <Helmet>
        <script
          async
          defer
          crossOrigin="anonymous"
          src="https://connect.facebook.net/en_US/sdk.js"
        ></script>
        <script
          async
          defer
          src={`https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&callback=initMap`}
        ></script>
      </Helmet>
      <Admin
        dataProvider={dataProvider}
        authProvider={authProviderBridge}
        loginPage={LoginPage}
        title="Podiya Admin"
        theme={customTheme}
      >
        {(role: UserRole) => {
          return (
            <>
              <CustomRoutes noLayout>
                <Route path="/" element={<RootPage />} />
                <Route
                  path="/auth/apple/callback"
                  element={<OAuthCallback />}
                />
              </CustomRoutes>
              {rolePermission.auth(role) ? (
                <Resource
                  list={EventsList}
                  edit={EventEdit}
                  create={EventCreate}
                  name="/events"
                  options={{ label: 'Events' }}
                  icon={EventIcon}
                />
              ) : null}

              {role === USER_ROLES.Admin ? (
                <>
                  <Resource
                    list={UsersList}
                    edit={UserEdit}
                    name="/users"
                    options={{ label: 'Users' }}
                    icon={GroupIcon}
                  />
                  <Resource
                    list={CategoriesList}
                    edit={CategoryEdit}
                    create={CategoryCreate}
                    name="/categories"
                    options={{ label: 'Categories' }}
                    icon={CategoryIcon}
                  />
                </>
              ) : null}
            </>
          );
        }}
      </Admin>
    </>
  );
};

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
